"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconEye = function SvgIconEye(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "eye icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Eye Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M43.538 22.085C39.623 15.441 32.32 11 24 11c-8.324 0-15.625 4.444-19.538 11.085a3.333 3.333 0 000 3.385C8.377 32.115 15.68 36.556 24 36.556c8.324 0 15.625-4.445 19.538-11.086a3.333 3.333 0 000-3.385zM24 33.222c-7.122 0-13.34-3.798-16.667-9.444 3.067-5.204 8.589-8.838 15.012-9.376a3.889 3.889 0 11-6.678 2.709v-.003a9.444 9.444 0 1015.84-1.283 19.206 19.206 0 019.16 7.953C37.34 29.424 31.122 33.222 24 33.222z"
  }));
};

var _default = SvgIconEye;
exports.default = _default;